import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["slot"]
  static values = { date: String }

  connect() {
    // Add drop zone handlers to all slots
    this.slotTargets.forEach(slot => {
      slot.addEventListener("dragover", this.handleDragOver.bind(this))
      slot.addEventListener("dragenter", this.handleDragEnter.bind(this))
      slot.addEventListener("dragleave", this.handleDragLeave.bind(this))
      slot.addEventListener("drop", this.handleDrop.bind(this))
    })
  }

  slotClicked(event) {
    // Don't navigate if clicking on an appointment block
    if (event.target.closest('.appointment-block')) {
      return
    }

    const slot = event.currentTarget
    const time = slot.dataset.time
    const date = this.dateValue

    // Navigate to new appointment form with time pre-filled
    window.location.href = `/appointments/new?date=${date}&start_time=${time}`
  }

  handleDragOver(event) {
    // Allow drop
    event.preventDefault()
    event.dataTransfer.dropEffect = "copy"
  }

  handleDragEnter(event) {
    event.preventDefault()
    const slot = event.currentTarget
    slot.classList.add("calendar-slot--drag-over")
  }

  handleDragLeave(event) {
    const slot = event.currentTarget
    // Only remove class if we're leaving the slot entirely
    if (!slot.contains(event.relatedTarget)) {
      slot.classList.remove("calendar-slot--drag-over")
    }
  }

  async handleDrop(event) {
    event.preventDefault()
    const slot = event.currentTarget
    slot.classList.remove("calendar-slot--drag-over")

    // Get task data from the drag event
    const taskId = event.dataTransfer.getData("application/x-task-id")
    const taskTitle = event.dataTransfer.getData("text/plain")
    const taskDuration = event.dataTransfer.getData("application/x-task-duration") || "30"
    const isRecurring = event.dataTransfer.getData("application/x-task-recurring") === "true"

    if (!taskId) {
      console.log("No task ID in drop data")
      return
    }

    const time = slot.dataset.time
    const date = this.dateValue

    // Create appointment from task
    try {
      const response = await fetch("/appointments/from_task", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({
          task_id: taskId,
          date: date,
          start_time: time,
          duration_minutes: parseInt(taskDuration)
        })
      })

      if (response.ok) {
        const data = await response.json()

        // If recurring task, ask about applying to siblings
        if (isRecurring && data.recurring_siblings_count > 0) {
          const apply = confirm(`Apply this time (${time}) to all ${data.recurring_siblings_count} future recurring instances?`)
          if (apply) {
            await this.applyTimeToRecurringSiblings(taskId, time, parseInt(taskDuration))
          }
        }

        // Reload the page to show the new appointment
        window.location.reload()
      } else {
        const error = await response.json()
        alert(`Error creating appointment: ${error.message || "Unknown error"}`)
      }
    } catch (err) {
      console.error("Failed to create appointment:", err)
      alert("Failed to create appointment. Please try again.")
    }
  }

  async applyTimeToRecurringSiblings(taskId, time, durationMinutes) {
    try {
      await fetch(`/tasks/${taskId}/apply_time_to_siblings`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({
          start_time: time,
          duration_minutes: durationMinutes
        })
      })
    } catch (err) {
      console.error("Failed to apply time to siblings:", err)
    }
  }
}
